<div class="container_filter">
    <div class="header">
      <div class="title-description">
        <h2 class="filter-title">
          {{ "segment.filter.title" | translate }}
        </h2>
        <p class="filter-description">
          {{ "filter.description" | translate }}
        </p>
      </div>
      <button class="close" (click)="close()">
        <img src="assets/icones/close.svg" alt="" />
      </button>
    </div>
  
    <div class="content">
      <div class="selection">
        <div class="import-and-selected">
          <ng-container *ngIf="segmentFilters?.filters?.length > 0">
            <button class="select-saved-filter" [matMenuTriggerFor]="menu">
              <img src="assets/icones/import-filter.svg" alt="" />
              <small>{{ "filter.import" | translate }}</small>
            </button>
            <mat-menu #menu="matMenu" class="import-menu" >
              <div class="filter_btn"
                *ngFor="let filter of segmentFilters?.filters || []"
                
              >
                <span (click)="setFilter(filter)"
                >{{ filter.name }}</span>
                <button (click)="deleteFilter(filter)" >
                  <img src="assets/icones/delete_btn.svg" alt="">
                </button>
              </div>
            </mat-menu>
          </ng-container>
          <div class="applied-filters-count" (click)="clearFilters()">
            <span class="count">{{ getFiltersCount() }}</span>
            <span>{{ "filter.applied" | translate }}</span>
            <img src="assets/icones/clear-filter.svg" alt="" />
          </div>
        </div>
        <div
          class="filter-group"
          [class.filter-group-selected]="selectedGroup === 'segment_info'"
        >
          <div class="group-title" (click)="selectedGroup = 'segment_info'">
            <img src="assets/icones/info.svg" alt="" />
            <h3>{{ "segment.filter.groups.segment_info" | translate }}</h3>
          </div>
          <div class="filters">
            <div class="filter" *ngIf="filter.segmentsInfoFilter.name">
              <span>
                {{ "segment.filter.fields.name" | translate }} :
                {{ filter.segmentsInfoFilter.name }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.segmentsInfoFilter.name = undefined"
              />
            </div>
            <div class="filter" *ngIf="filter.segmentsInfoFilter.status">
              <span>
                {{ "segment.filter.fields.status" | translate }} :
                {{
                  "segment.filter.values." + filter.segmentsInfoFilter.status
                    | translate
                }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.segmentsInfoFilter.status = undefined"
              />
            </div>
          </div>
        </div>
        <div
          class="filter-group"
          [class.filter-group-selected]="selectedGroup === 'locations_info'"
        >
          <div class="group-title" (click)="selectedGroup = 'locations_info'">
            <img src="assets/icones/companies.svg" alt="" />
            <h3>{{ "segment.filter.groups.locations_info" | translate }}</h3>
          </div>
          <div class="filters">
            <div
            class="filter"
            *ngIf="
              filter.advancedFilter.nbr_locations_min ||
              filter.advancedFilter.nbr_locations_max
            "
          >
            <span>
              {{ "segment.filter.fields.nbr_locations" | translate }} :
              <ng-container *ngIf="filter.advancedFilter.nbr_locations_min">
                {{ "common.from" | translate }}
                {{ filter.advancedFilter.nbr_locations_min }} €
              </ng-container>
              <ng-container *ngIf="filter.advancedFilter.nbr_locations_max">
                {{ "common.to" | translate }}
                {{ filter.advancedFilter.nbr_locations_max }} €
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.advancedFilter.nbr_locations_min= undefined;
                filter.advancedFilter.nbr_locations_max = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.advancedFilter.locations.length > 0">
            <span>
              {{ "segment.filter.fields.locations" | translate }} :
              {{ getLocationsNames() }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="filter.advancedFilter.locations= []"
            />
          </div>
          </div>
        </div> 
      </div>
      <div class="form">
        <ng-container *ngIf="selectedGroup === 'segment_info'">
          <div class="form-title">
            <img src="assets/icones/info.svg" alt="" />
            <h3>{{ "segment.filter.groups." + selectedGroup | translate }}</h3>
          </div>
          <div class="inputs">
            <div class="field">
              <label for="name">{{
                "segment.filter.fields.name" | translate
              }}</label>
              <input
                id="name"
                type="text"
                [(ngModel)]="filter.segmentsInfoFilter.name"
                [placeholder]="'segment.filter.fields.name' | translate"
              />
            </div>
            <div class="field">
              <label for="">{{
                "segment.filter.fields.status" | translate
              }}</label>
              <select [(ngModel)]="filter.segmentsInfoFilter.status">
                <option value="" disabled selected>
                  {{ "segment.filter.fields.status" | translate }}
                </option>
                <option value="draft">
                  {{ "segment.filter.values.draft" | translate }}
                </option>
                <option value="published">
                  {{ "segment.filter.values.published" | translate }}
                </option>
              </select>
            </div>
            <div class="field">
              <label for="">{{
                "segment.filter.fields.value_type" | translate
              }}</label>
              <select [(ngModel)]="filter.segmentsInfoFilter.value_type">
                <option value="" disabled selected>
                  {{ "segment.filter.fields.value_type" | translate }}
                </option>
                <option value="single-select">
                  {{ "segment.filter.values.single_select" | translate }}
                </option>
                <option value="multi-select">
                  {{ "segment.filter.values.multi_select" | translate }}
                </option>
                <option value="boolean">
                  {{ "segment.filter.values.yes_no" | translate }}
                </option>
                <option value="text">
                  {{ "segment.filter.values.label" | translate }}
                </option>
              </select>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedGroup === 'locations_info'">
          <div class="form-title">
            <img src="assets/icones/companies.svg" alt="" />
            <h3>{{ "segment.filter.groups." + selectedGroup | translate }}</h3>
          </div>
  
          <div class="inputs">
            <div class="inputs-pair">
              <div class="field">
                <label for="nbr_locations_min">{{
                  "segment.filter.fields.nbr_locations_min" | translate
                }}</label>
                <input
                  id="nbr_locations_min"
                  type="number"
                  min="0"
                  [max]="filter.advancedFilter.nbr_locations_max || 1"
                  [(ngModel)]="filter.advancedFilter.nbr_locations_min"
                  [placeholder]="
                    'segment.filter.fields.nbr_locations_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="nbr_locations_max">{{
                  "segment.filter.fields.nbr_locations_max" | translate
                }}</label>
                <input
                  id="nbr_locations_max"
                  type="number"
                  [min]="filter.advancedFilter.nbr_locations_min || 0"
                  [(ngModel)]="filter.advancedFilter.nbr_locations_max"
                  [placeholder]="
                    'segment.filter.fields.nbr_locations_max' | translate
                  "
                />
              </div>
            </div>
            <div class="field equality_field">
              <label for="">{{
                "segment.filter.fields.locations" | translate
              }}</label>
              <mat-chip-list #locationsChipList>
                <mat-chip
                  *ngFor="
                    let location of filter.advancedFilter.locations;
                    index as i
                  "
                  (removed)="filter.advancedFilter.locations.splice(i, 1)"
                >
                  {{ location.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'segment.filter.fields.locations' | translate"
                  #fruitInput
                  (input)="filterLocations()"
                  [(ngModel)]="locationsFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="locationsAutoComplete"
                  [matChipInputFor]="locationsChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete #locationsAutoComplete="matAutocomplete">
                <ng-container *ngIf="filteredlocations$ | async as locations">
                  <mat-option
                    *ngFor="let location of locations"
                    [value]="location.id"
                    (click)="selectLocation(location)"
                  >
                    {{ location.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="footer submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
          <span>{{"common.cancel"|translate | uppercase}}</span>
          <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <div class="save-apply">
        <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
          <div class="label-action">
            <label for="filter_name">{{
              "filter.filter_name" | translate
            }}</label>
            <div class="actions">
              <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate }}</button>
              <button class="save-btn" (click)="save()">
                {{ "common.save" | translate | uppercase }}
              </button>
            </div>
          </div>
          <input
            id="filter_name"
            type="text"
            class="filter-name-input"
            [placeholder]="'filter.filter_name' | translate"
            [(ngModel)]="filterName"
            [formControl]="filterNameControl"
          />
          <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
            {{ "common.required_field" | translate }}
          </span>
        </div>
        <button
          class="save save_filter"
          [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm"
          (click)="toggleSaveFilter()"
        >
          <img src="assets/icones/save-filter.svg" alt="" />
          <small>{{ "filter.save" | translate }}</small>
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="apply()">
          <small>{{ "filter.apply" | translate | uppercase }}</small>
          <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
      </div>
    </div>
  </div>
  